module.exports = __webpack_public_path__ + "static/img/b7_body.39fa7d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b7_body.png
// module id = ozyq
// module chunks = 1